module.exports = __webpack_public_path__ + "img/9788992263078.e2df477b.jpg";